// Libs
import { amplitudeEventLogger, amplitudeCategories } from "@collectivehealth/frontend-analytics";
import { Session } from "@collectivehealth/cog";

// Hooks
import useQueryParams from "hooks/useQueryParams";

// Constants
import { USER_EVENTS } from "constants/analytics";
import { QUERY_PARAMS } from "constants/routing";

export default function Logout() {
  const queryParams = useQueryParams();

  if (queryParams[QUERY_PARAMS.TRACK_LOGOUT]) {
    amplitudeEventLogger(USER_EVENTS.LOGOUT_SUBMIT, {
      category: amplitudeCategories.LOGIN
    });
  }

  Session.endSession();

  return null;
}
